import request from '../../utilities/request';
import * as config from '../../config';
import * as shareholderTypes from './shareholderTypes';

export const getShareholdersSuccess = (summary) => {
    return {
        type: shareholderTypes.GET_SHAREHOLDERS_LIST_SUCCESS,
        payload: summary,
    };
};

export const setShareholdersLoading = (loading) => {
    return {
        type: shareholderTypes.SET_SHAREHOLDERS_LIST_LOADING,
        payload: loading,
    };
};

export const getShareholdersList = () => {
    return (dispatch) => {
        dispatch(setShareholdersLoading(true));
        request
            .get(`${config.API_BASE_URL}/shareholders/list`)
            .then((res) => {
                dispatch(getShareholdersSuccess(res.data));
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(setShareholdersLoading(false));
            });
    };
};
